import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import customTheme from "config/theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      gap: theme.spacing(4),
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
    leftSection: {
      flex: 2,
      "& input:disabled": {
        color: "#777",
      },
      [theme.breakpoints.down("md")]: {
        order: 2, // Left section appears second on mobile
      },
    },
    rightSection: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(2),
      minWidth: 250,
      marginTop: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        width: "100%",
        order: 1, // Right section appears first on mobile
      },
    },
    avatarContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    editButton: {
      textTransform: "none",
      color: (customTheme as any).bgButton,
      borderColor: (customTheme as any).bgButton,
    },
    changePasswordContainer: {
      marginTop: theme.spacing(3),
      textAlign: "center",
    },
    changePasswordLink: {
      color: (customTheme as any).bgButton,
      textDecoration: "underline",
      cursor: "pointer",
      fontSize: 15,
      "&:hover": {
        color: "#5a36d5",
      },
    },
    locationInput: {
      padding: "0 0 7px 0",
      borderBottom: "1px solid #dddddd",
      "& input": {
        padding: 0,
        fontSize: 13,
      },
      "& .MuiInput-underline:before": {
        display: "none",
      },
      "& .MuiInput-underline:after": {
        display: "none",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        display: "none",
      },
    },
    locationFieldContainer: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    locationFieldHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: "#adadad",
      textTransform: "uppercase",
      marginBottom: 2,
    },
    locationFieldLabel: {
      fontWeight: 500,
      fontSize: 12,
    },
    locationFieldActions: {
      display: "flex",
    },
    locationFieldIconButton: {
      padding: "4px",
      color: (customTheme as any).bgButton,
    },
  })
);

export default useStyles;
